import { useEffect } from 'react';

import type { DisplayMode } from 'src/components';

/**
 * Clears any active row-grouping model when the grid is in relationship mode.
 *
 * Relationship mode owns the tree layout, so leftover grouping fields would
 * conflict. The length guard is load-bearing: React.Activity tears this effect
 * down when the tab hides and remounts it on show. An unconditional
 * `setRowGroupingModel([])` would hand back a fresh empty array each resume,
 * which reads as a grouping change in `useReportDataSource` and clears the
 * data-source cache + row counts — a visible grid refresh on every tab switch.
 */
export function useClearRowGroupingInRelationshipMode({
  displayMode,
  rowGroupingModel,
  setRowGroupingModel,
}: {
  displayMode: DisplayMode;
  rowGroupingModel: string[];
  setRowGroupingModel: (model: string[]) => void;
}): void {
  useEffect(() => {
    if (displayMode === 'relationship' && rowGroupingModel.length > 0) setRowGroupingModel([]);
  }, [displayMode, rowGroupingModel, setRowGroupingModel]);
}
